// extracted by mini-css-extract-plugin
export default {"login-form":"login-form_login-form__dqo4T","title":"login-form_title__li36B","secondary-title":"login-form_secondary-title__Y0hTz"};